/** Client-side matching for directory lists. Empty selection means “any”. */

export function matchesQuery(query: string | null | undefined, fields: Array<string | null | undefined>): boolean {
  const needle = query?.trim().toLowerCase() ?? '';
  if (needle.length === 0) return true;
  return fields.some((field) => (field ?? '').toLowerCase().includes(needle));
}

export function selectedAllows(selected: string[], value: string): boolean {
  return selected.length === 0 || selected.includes(value);
}

export function compareText(left: string, right: string): number {
  return left.localeCompare(right, undefined, { sensitivity: 'base' });
}

export function compareNullableDate(left: string | null, right: string | null): number {
  if (left === right) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  return left.localeCompare(right);
}
